import { Context } from "chartjs-plugin-datalabels";

export const displayDataLabel = (value: number, context: Context) => {
  const datasetArray: number[] = [];
  context.chart.data.datasets.forEach((dataset) => {
    if (dataset.data[context.dataIndex] !== null) {
      datasetArray.push(dataset.data[context.dataIndex] as number);
    }
  });

  const formattedValue =
    value !== null
      ? value.toLocaleString("en-US", {
          useGrouping: true,
          maximumFractionDigits: 2,
        })
      : null;

  return datasetArray.length === 1 ? "" : formattedValue;
};

export const displayPercent = (value: number, context: Context) => {
  const datasetObject: { [key: string]: { [key: string]: number } } = {};
  const datasetArray: number[] = [];

  context.chart.data.datasets.forEach((dataset) => {
    if (dataset.data[context.dataIndex] !== null) {
      datasetArray.push(dataset.data[context.dataIndex] as number);
    }
  });

  context.chart.data.datasets.forEach((dataset) => {
    if (dataset.data.length && dataset.label) {
      const label = dataset.label;
      const values = dataset.data;

      if (!datasetObject[label]) {
        datasetObject[label] = {};
      }

      values.forEach((value, index) => {
        if (value !== null) {
          // @ts-ignore
          datasetObject[label][context.chart.data.labels[index]] = value;
        }
      });
    }
  });

  if (
    context.dataIndex > 0 &&
    context.chart.data.labels?.length &&
    context.dataset.label?.length &&
    datasetArray.length > 1
  ) {
    const previousLabel = context.chart.data.labels[context.dataIndex - 1];
    const currentValue = value;
    // @ts-ignore
    const previousValue = datasetObject[context.dataset.label][previousLabel];

    const percentageIncrease = (
      ((currentValue - previousValue) / previousValue) *
      100
    ).toFixed(1);

    const parsedValue = Number(percentageIncrease);

    return !!parsedValue
      ? `${parsedValue > 0 ? "+" : ""}${parsedValue}%`
      : null;
  }
  return null;
};
